import axios, { AxiosResponse } from 'axios';
import { CasinoCommandNames } from 'utils/constants/casino/casino-command-names';
import { CASINO_LANG_EXCEPTIONS } from 'utils/constants/languages/language-format';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { GLOBALS } from 'utils/generic/global-variables';
import { isMobile } from 'utils/is-mobile';
import {
  IGetCasinoGamesResponse,
  NewCasinoGamesFetchingParams
} from 'interfaces/new-casino';

const lang = SpringConfigs.CURRENT_LANGUAGE;

const fetchLang =
  GLOBALS.languageConfigs.casinoLangPrefix ||
  CASINO_LANG_EXCEPTIONS[lang] ||
  CASINO_LANG_EXCEPTIONS[lang.slice(0, 2)] ||
  SpringConfigs.LANGUAGE_PREFIX;

const defaultParams: Partial<NewCasinoGamesFetchingParams> = {
  partner_id: SpringConfigs.PARTNER_ID,
  is_mobile: Number(isMobile()),
  lang: fetchLang,
  use_webp: Number(SpringConfigs.IS_WEBP_SUPPORTED),
  offset: 0,
  country: SpringConfigs.CURRENT_COUNTRY_CODE,
  with_bet_limits: 1
};

export const getCasinoGames = async <T = IGetCasinoGamesResponse>(
  _params: Partial<NewCasinoGamesFetchingParams>
) => {
  const url = SpringConfigs.DECENTRALIZED_CASINO_URL
    ? `${SpringConfigs.DECENTRALIZED_CASINO_URL}${CasinoCommandNames.GET_DECENTRALIZED_GAMES}`
    : `${SpringConfigs.CASINO_URL}/${CasinoCommandNames.GET_GAMES}`;

  const params = SpringConfigs.DECENTRALIZED_CASINO_URL
    ? {
        partnerId: SpringConfigs.DECENTRALIZED_CASINO_PARTNER_ID,
        lang: defaultParams.lang,
        categoryId: _params.category?.includes(',')
          ? undefined
          : _params.category,
        offset: _params.offset || 0,
        limit: _params.limit || SpringConfigs.CASINO_GAMES_FETCH_COUNT
      }
    : { ...defaultParams, ..._params, _all_categories: undefined };

  return await axios.get<T, AxiosResponse<T>>(url, { params });
};

export const getPromotedCasinoGames = async <T = IGetCasinoGamesResponse>(
  _params: Partial<NewCasinoGamesFetchingParams>
) => {
  const url = `${SpringConfigs.CASINO_URL}/${CasinoCommandNames.GET_PROMOTED_GAMES}`;

  const params = { ...defaultParams, ..._params };

  return await axios.get<T, AxiosResponse<T>>(url, { params });
};
